import React from "react";
import TopNav from "../TopNav/TopNav";
// import Header from "../Header/Header";
import NewHeader from "../NewHeader/NewHeader";
import Footer from "../Footer/Footer";
import Banner from "../../Pages/patientTestimonial/Banner";
import { SingleComponent } from "../../Pages/NewAbout";
import diagnostic from "../../Assets/newAsset/diagnostic/DSC_9074.png";
import Content from "../../Pages/homePage/Components/Content";
import Featured from "../../Pages/homePage/Components/Featured";
import FAQforhomepage from "../../Pages/homePage/FAQforhomepage";
import cardimg from "../../Assets/newAsset/diagnostic/microbiology.png";

//IMPORT IMAGES
import "./Diagnostic.css";
const Diagnostic = () => {
  const cardArray = [
    {
      id: 1,
      img: "src",
      desc: "Microbiology, Serology & Immunology",
    },
    {
      id: 2,
      img: "src",
      desc: "Biochemistry & Immunoassay",
    },
    {
      id: 3,
      img: "src",
      desc: "Hormone Assays",
    },
    {
      id: 4,
      img: "src",
      desc: "Hematopathology",
    },
    {
      id: 5,
      img: "src",
      desc: "Histopathology",
    },
  ];
  return (
    <>
      {/* <TopNav /> */}
      <NewHeader />
      <Banner title="Best Diagnostic Centre in Delhi" />
      <SingleComponent
        img={diagnostic}
        title="About Us"
        firstPara="Once diagnosed with covid-19, it is important to progressively monitor the presence of Cytokine level as excess development of it causes ARDS ( Acute Respiratory Distress Syndrome) which damage tissues, causes multiple organ failure and then death. Mortality in covid-19 patients chains more due to the presence of “Cytokine Storm”, excess production of cytokine-induced by SARS-CoV-2. Hence it is vital to have a keen eye on the check-ups."
      />
      <Content title="Our Best Health Packages in Delhi" Ispackage={true} />
      <div className="Services bg_gray">
        <div className="container   diagnostic_content">
          <div>
            <h2 className="heading">Our Services</h2>
            <p className="subheading">All Imaging Services Under One Roof</p>
          </div>
          <div className="card_row">
            <div className="card">
              <img src={cardimg} alt="card1" />
              <span className="card_des">
                Microbiology, Serology & Immunology
              </span>
            </div>

            <div className="card">
              <img src={cardimg} alt="card1" />
              <span className="card_des">
                Microbiology, Serology & Immunology
              </span>
            </div>

            <div className="card">
              <img src={cardimg} alt="card1" />
              <span className="card_des">
                Microbiology, Serology & Immunology
              </span>
            </div>

            <div className="card">
              <img src={cardimg} alt="card1" />
              <span className="card_des">
                Microbiology, Serology & Immunology
              </span>
            </div>

            <div className="card">
              <img src={cardimg} alt="card1" />
              <span className="card_des">
                Microbiology, Serology & Immunology
              </span>
            </div>

            <div className="card">
              <img src={cardimg} alt="card1" />
              <span className="card_des">
                Microbiology, Serology & Immunology
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg_light">
        <div className="pathologyDesc container">
          <div>
            <h2 className="heading">Top Pathology lab in Delhi</h2>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam
          </p>
        </div>
      </div>

      <FAQforhomepage />
      <Content title="Testimonials" Ispackage={false} isTestimonial={true} />
      <Featured />
      <Footer />
    </>
  );
};

export default {
  component: Diagnostic,
};
